import { Component, Input } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { IServicesOffering } from 'src/app/model/sitefinity/IServicesOffering';
import { TechServicesModalComponent } from './tech-services-modal/tech-services-modal.component';
@Component({
  selector: 'app-discount-offers-section',
  templateUrl: './discount-offers-section.component.html',
  styleUrls: ['./discount-offers-section.component.scss'],
})
export class DiscountOffersSectionComponent {
  @Input() serviceOfferings: IServicesOffering[];
  @Input() contractId: string;
  @Input() userEmail: string;
  @Input() userType: string;
  @Input() usersOnContract: number;

  constructor(public matDialog: MatDialog) {}

  openModal = (serviceOffering: IServicesOffering) => {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.id = serviceOffering.id;
    dialogConfig.height = 'auto';
    dialogConfig.data = { ...serviceOffering, contractId: this.contractId };

    this.matDialog.open(TechServicesModalComponent, dialogConfig);
  };
}
